import { $gte as __gte, createQueryOperator } from "../../_predicates";
const $gte = createQueryOperator(__gte);
export {
  $gte
};
